import { Injectable, Injector } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';

//import { AuthService } from "./auth/auth.service";
import { ConfigurationService } from './configuration.service';

// Models
import { JwtRequest, JwtResponse } from '../models/user.models';

// Cognito
import { CognitoService } from '../services/cognito/cognito.service';
import { CustomHeaders } from '../models/http/http.model';

/**
 *
 */
@Injectable()
export class EndpointFactory {
    static readonly apiVersion: string = '1';

    private readonly _loginUrl: string = '/api/jwt/token';

    private get loginUrl() {
        return this.configurations.baseUrl + this._loginUrl;
    }

    private taskPauser: Subject<any>;
    private isRefreshingLogin: boolean;

    //   private _authService: AuthService;

    //   protected get authService() {
    //     if (!this._authService) this._authService = this.injector.get(AuthService);

    //     return this._authService;
    //   }

    constructor(protected http: HttpClient, protected configurations: ConfigurationService, private injector: Injector, private cognitoService: CognitoService) { }

    /**
     * Returns header for api request.
     * @param responseType Otional response type. 'application/json' is default
     */
    protected getRequestHeaders(responseType?: string, customHeaders?: CustomHeaders): { headers: HttpHeaders | { [header: string]: string | string[] } } {
        if (responseType == null) responseType = 'application/json';

        const headerContent = {
            Authorization: this.cognitoService.idToken,
            'Content-Type': responseType,
            Accept: `application/vnd.iman.v${EndpointFactory.apiVersion}+json, ${responseType}, text/plain, */*`,
        };

        if (customHeaders) {
            for (let key in customHeaders) {
                headerContent[key] = customHeaders[key];
            }
        }

        const headers = new HttpHeaders(headerContent);

        return { headers: headers };
    }

    protected getHttpRequestHeaders(responseType?: string, customHeaders?: CustomHeaders): HttpHeaders {
        if (responseType == null) responseType = 'application/json';

        const headers = new HttpHeaders({
            'Authorization': this.cognitoService.idToken,
            'Content-Type': responseType,
            'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
        });

        if (customHeaders) {
            for (let key in customHeaders) {
                headers.set(key,customHeaders[key])
            }
        }

        return headers;
    }

    /**
     * Returns header for api request.
     * @param responseType Otional response type. 'application/json' is default
     */
    protected getRequestHeadersNoAccept(responseType?: string, accept?: string, customHeaders?: CustomHeaders): { headers: HttpHeaders | { [header: string]: string | string[] } } {
        if (responseType == null) responseType = 'application/json';
        if (accept == null) accept = `application/vnd.iman.v${EndpointFactory.apiVersion}+json, ${responseType}, text/plain, */*`;

        const headerContent = {
            Authorization: this.cognitoService.idToken,
            'Content-Type': responseType,
            Accept: accept,
        };

        if (customHeaders) {
            for (let key in customHeaders) {
                headerContent[key] = customHeaders[key];
            }
        }

        const headers = new HttpHeaders(headerContent);

        return { headers: headers };
    }
    /**
     * Returns header for api request.
     * @param responseType Otional response type. 'application/json' is default
     */
    protected getRequestFAKEHeaders(responseType?: string, cognitoProdTokenId?: string, customHeaders?: CustomHeaders): { headers: HttpHeaders | { [header: string]: string | string[] } } {
        if (responseType == null) responseType = 'application/json';
        if (cognitoProdTokenId == null) cognitoProdTokenId = this.cognitoService.idToken;

        const headerContent = {
            Authorization: cognitoProdTokenId,
            'Content-Type': responseType,
            Accept: `application/vnd.iman.v${EndpointFactory.apiVersion}+json, ${responseType}, text/plain, */*`,
        };

        if (customHeaders) {
            for (let key in customHeaders) {
                headerContent[key] = customHeaders[key];
            }
        }

        const headers = new HttpHeaders(headerContent);

        return { headers: headers };
    }

    /**
     * Restituisce la query string formattata opportunamente per la gestione della paginazione.
     * @param pageIndex Indice della pagina da inserire nella query string.
     * @param pageSize Dimensione della pagina da inserire nella query string.
     */
    //getPagingParameters(pageIndex: number, pageSize: number): string
    getPagingParameters(skip: number, take: number): string {
        //return `?PageIndex=${pageIndex}&PageSize=${pageSize}`;
        return `?Skip=${skip}&Take=${take}`;
    }

    //#endregion
    protected handleError(error, continuation?: () => Observable<any>) {
        if (error.status == 401) {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            if (error.status === 401) {
                this.cognitoService.refreshSession();
            }
        } else {
            return Observable.throw(error || 'errore server');
        }
    }

    private pauseTask(continuation: () => Observable<any>) {
        if (!this.taskPauser) this.taskPauser = new Subject();

        return this.taskPauser.switchMap((continueOp) => {
            return continueOp ? continuation() : Observable.throw('sessione scaduta');
        });
    }

    private resumeTasks(continueOp: boolean) {
        setTimeout(() => {
            if (this.taskPauser) {
                this.taskPauser.next(continueOp);
                this.taskPauser.complete();
                this.taskPauser = null;
            }
        });
    }
}
